import { render, staticRenderFns } from "./org.vue?vue&type=template&id=bbb8b996&scoped=true&"
import script from "./org.vue?vue&type=script&lang=js&"
export * from "./org.vue?vue&type=script&lang=js&"
import style0 from "./org.vue?vue&type=style&index=0&id=bbb8b996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb8b996",
  null
  
)

export default component.exports